import { object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  id: string().required(),
  status: string().oneOf(['pending', 'completed', 'failed']).required(),
  message: string().required(),
});

/**
 * ExportLogCreateEvent
 *
 * - Evento emitido quando uma exportação gera um log novo.
 */
export class ExportLogCreateEvent extends CreateCommand(RealtimeEventType.ExportLogCreate, SCHEMA) {}
